"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesChannelCode = exports.FeatureLevel = exports.Service = exports.OnboardingNavigationRoutes = exports.OnboardingSection = exports.OnboardingCheckList = exports.OnboardingArea = exports.OnboardingAction = exports.DeviceMode = exports.App = exports.BusinessSize = exports.BusinessStatus = exports.BusinessType = void 0;
var BusinessType;
(function (BusinessType) {
    BusinessType["CAFETERIA"] = "CAFETERIA";
    BusinessType["PIZZERIA"] = "PIZZERIA";
    BusinessType["RETAIL"] = "RETAIL";
    BusinessType["FRANCHISEE"] = "FRANCHISEE";
    BusinessType["FINE_DINING"] = "FINE_DINING";
    BusinessType["BAR_AND_RESTAURANT"] = "BAR_AND_RESTAURANT";
})(BusinessType = exports.BusinessType || (exports.BusinessType = {}));
var BusinessStatus;
(function (BusinessStatus) {
    BusinessStatus["NEW_BUSINESS"] = "NEW_BUSINESS";
    BusinessStatus["EXISTING_BUSINESS"] = "EXISTING_BUSINESS";
})(BusinessStatus = exports.BusinessStatus || (exports.BusinessStatus = {}));
var BusinessSize;
(function (BusinessSize) {
    BusinessSize["SMALL"] = "1";
    BusinessSize["MEDIUM"] = "2-4";
    BusinessSize["BIG"] = "5+";
})(BusinessSize = exports.BusinessSize || (exports.BusinessSize = {}));
var App;
(function (App) {
    App["POS_APP"] = "POS_APP";
    App["ONLINE_STORE"] = "ONLINE_STORE";
    App["OOLIO_STORE"] = "OOLIO_STORE";
    App["GUESTBOOK"] = "GUESTBOOK";
    App["BACKOFFICE"] = "BACKOFFICE";
    App["CUSTOMER_DISPLAY_APP"] = "CUSTOMER_DISPLAY_APP";
    App["M_POS"] = "M_POS";
    App["KITCHEN_DISPLAY_APP"] = "KITCHEN_DISPLAY_APP";
    App["DEPUTY"] = "DEPUTY";
    App["OOLIO_KIOSK"] = "OOLIO_KIOSK";
    App["KIOSK"] = "KIOSK";
    App["OOM"] = "OOM";
    App["OOLIO_RESERVATION"] = "OOLIO_RESERVATION";
    App["OOLIO_WAITLISTS"] = "OOLIO_WAITLISTS";
})(App = exports.App || (exports.App = {}));
var DeviceMode;
(function (DeviceMode) {
    DeviceMode["F_POS"] = "F_POS";
    DeviceMode["M_POS"] = "M_POS";
    DeviceMode["KIOSK"] = "KIOSK";
})(DeviceMode = exports.DeviceMode || (exports.DeviceMode = {}));
var OnboardingAction;
(function (OnboardingAction) {
    OnboardingAction["READ"] = "READ";
    OnboardingAction["CREATE"] = "CREATE";
    OnboardingAction["UPDATE"] = "UPDATE";
    OnboardingAction["DELETE"] = "DELETE";
})(OnboardingAction = exports.OnboardingAction || (exports.OnboardingAction = {}));
var OnboardingArea;
(function (OnboardingArea) {
    OnboardingArea["SETTINGS"] = "SETTINGS";
    OnboardingArea["CATALOGUES"] = "CATALOGUES";
})(OnboardingArea = exports.OnboardingArea || (exports.OnboardingArea = {}));
var OnboardingCheckList;
(function (OnboardingCheckList) {
    OnboardingCheckList["VENUES"] = "VENUES";
    OnboardingCheckList["STORES_REGISTER_PROFILES"] = "STORES_REGISTER_PROFILES";
    OnboardingCheckList["TAXES_FEES"] = "TAXES_FEES";
    OnboardingCheckList["PAYMENT_TYPES"] = "PAYMENT_TYPES";
    OnboardingCheckList["PAGES"] = "PAGES";
    OnboardingCheckList["PRODUCTS"] = "PRODUCTS";
})(OnboardingCheckList = exports.OnboardingCheckList || (exports.OnboardingCheckList = {}));
// ActionSheet can be formed by using area, sections and actions separated by #
var OnboardingSection;
(function (OnboardingSection) {
    OnboardingSection["VIEW_VENUE_SETUP"] = "VIEW_VENUE_SETUP";
    OnboardingSection["VIEW_STORE_AND_REGISTER_SETUP"] = "VIEW_STORE_AND_REGISTER_SETUP";
    OnboardingSection["VIEW_ADD_TAXES"] = "VIEW_ADD_TAXES";
    OnboardingSection["VIEW_ADD_PAYMENT_TYPE"] = "VIEW_ADD_PAYMENT_TYPE";
    OnboardingSection["ADD_A_PAGE_AND_PRODUCT"] = "ADD_A_PAGE_AND_PRODUCT";
})(OnboardingSection = exports.OnboardingSection || (exports.OnboardingSection = {}));
var OnboardingNavigationRoutes;
(function (OnboardingNavigationRoutes) {
    OnboardingNavigationRoutes["NAVIGATE_TO_VENUE"] = "NAVIGATE_TO_VENUE";
    OnboardingNavigationRoutes["NAVIGATE_TO_STORE_REGISTER"] = "NAVIGATE_TO_STORE_REGISTER";
    OnboardingNavigationRoutes["NAVIGATE_TO_TAXES"] = "NAVIGATE_TO_TAXES";
    OnboardingNavigationRoutes["NAVIGATE_TO_PAYMENT_TYPES"] = "NAVIGATE_TO_PAYMENT_TYPES";
    OnboardingNavigationRoutes["NAVIGATE_TO_PRODUCTS"] = "NAVIGATE_TO_PRODUCTS";
    OnboardingNavigationRoutes["NAVIGATE_TO_PAGES"] = "NAVIGATE_TO_PAGES";
})(OnboardingNavigationRoutes = exports.OnboardingNavigationRoutes || (exports.OnboardingNavigationRoutes = {}));
var Service;
(function (Service) {
    Service["ACCOUNTS"] = "accounts";
    Service["ANALYTICS"] = "analytics";
    Service["CATALOGUES"] = "catalogues";
    Service["CUSTOMERS"] = "customers";
    Service["EVENTS"] = "events";
    Service["ORDERS"] = "orders";
    Service["ORGANIZATIONS"] = "organizations";
    Service["PRODUCTS"] = "products";
    Service["REPORTING"] = "reporting";
    Service["SERVICE_TEMPLATE"] = "service-template";
    Service["SHIFTS"] = "shifts";
    Service["STAFF"] = "staff";
    Service["VENUES"] = "venues";
})(Service = exports.Service || (exports.Service = {}));
var FeatureLevel;
(function (FeatureLevel) {
    FeatureLevel["ORGANIZATION"] = "ORGANIZATION";
    FeatureLevel["VENUE"] = "VENUE";
    FeatureLevel["STORE"] = "STORE";
})(FeatureLevel = exports.FeatureLevel || (exports.FeatureLevel = {}));
var SalesChannelCode;
(function (SalesChannelCode) {
    SalesChannelCode["IN_STORE"] = "IN_STORE";
    SalesChannelCode["ONLINE"] = "ONLINE";
})(SalesChannelCode = exports.SalesChannelCode || (exports.SalesChannelCode = {}));
//# sourceMappingURL=organizations.js.map